export default {
  email: null,
  mensagemSucesso: null,
  mensagemErro: null
}
